import PropTypes from "prop-types";
import React from "react";
import getClassNameFactory from "../../../../../utilities/classNames";
import Link from "../../../../../elements/Link";

var LinkCardFooter = function LinkCardFooter(_ref) {
  var type = _ref.type,
      title = _ref.title;
  var getClassName = getClassNameFactory(LinkCardFooter.displayName);
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName()
  }, /*#__PURE__*/React.createElement(Link, {
    type: type
  }, title));
};

LinkCardFooter.displayName = "LinkCardFooter";
/* eslint-disable max-len */

LinkCardFooter.propTypes = {
  /**
   * Type of link
   */
  type: PropTypes.oneOf(["primary", "action"]),

  /**
   * Title text
   */
  title: PropTypes.string.isRequired
};
/* eslint-enable max-len */

LinkCardFooter.defaultProps = {
  type: "primary"
};
export default LinkCardFooter;